import menuApi from '@/api/menu';
import store from '@/store';
import { Module, VuexModule, getModule, Mutation, Action } from 'vuex-module-decorators';
import { IMenu, ITemplate } from '@/types/menu';

@Module({ dynamic: true, store, name: 'menu' })
class MenuModlue extends VuexModule {
  menuData: IMenu[] = [];
  templates: ITemplate[] = [];

  @Mutation
  setMenu(menu: IMenu[]) {
    this.menuData = menu;
  }

  @Mutation
  setTemplate(templates: ITemplate[]) {
    this.templates = templates;
  }

  @Action({ rawError: true })
  async fetchMenuData() {
    const { data } = await menuApi.getMenuInfo();
    this.setMenu(data);
  }

  @Action({ rawError: true })
  async fetchTemplates() {
    const { data } = await menuApi.fetchTemplates();
    this.setTemplate(data);
    return data;
  }

  @Action({ rawError: true })
  async changeMenuData(menuData: IMenu[]) {
    await menuApi.setMenuInfo(menuData);
    this.setMenu(menuData);
    return;
  }
}
export const menuModule = getModule(MenuModlue);
